// onKeyDown for an auth <form>: Enter in a text field moves to the next field; in the last one it falls through
// to the form's normal submit. Hidden inputs (the country select's) and checkboxes are skipped.
export const enterToNext = (e) => {
  if (e.key !== "Enter" || e.shiftKey || e.nativeEvent.isComposing) return;
  if (e.target.tagName !== "INPUT") return;

  const fields = [...e.currentTarget.querySelectorAll("input")].filter(input => (
    !input.disabled
    && !["hidden", "checkbox", "radio"].includes(input.type)
    && input.getAttribute("aria-hidden") !== "true"
    && input.offsetParent !== null
  ));
  const index = fields.indexOf(e.target);
  if (index < 0 || index === fields.length - 1) return;

  e.preventDefault();
  fields[index + 1].focus();
};
